interface RearAndMachineSVGProps {
  color: string;
  style: React.CSSProperties;
}

const RearAndMachineSVG = ({ color, style }: RearAndMachineSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="53"
    viewBox="0 0 60 53"
    fill="none"
  >
    <g clipPath="url(#clip0_564_17711)">
      <path
        d="M22.6386 38.0691C15.7539 38.0691 10.1812 32.2051 10.1812 24.9869C10.1812 17.7687 15.7652 11.9047 22.6386 11.9047"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.7322 18.6283C43.035 18.1808 43.3601 17.7452 43.7302 17.3448L44.6384 16.3557L40.7475 9.29059L39.4693 9.6203C36.8679 10.3033 34.132 9.83225 31.8109 8.41923C31.7885 8.40745 31.7548 8.3839 31.7324 8.37213C29.4001 6.95911 27.6285 4.71005 26.8772 1.98999L26.5184 0.671173H18.7479L18.3891 2.00177C17.6378 4.72183 15.8774 6.97088 13.5451 8.3839C13.5339 8.3839 13.5227 8.39568 13.5115 8.40745C13.5003 8.40745 13.4891 8.41923 13.4779 8.431C11.1456 9.84402 8.40965 10.3268 5.79706 9.64385L4.51879 9.31414L0.62793 16.3557L1.53617 17.3448C3.40872 19.3819 4.38424 22.1255 4.37302 24.9516C4.37302 24.9869 4.37302 25.0104 4.37302 25.0458C4.37302 27.86 3.39751 30.5919 1.53617 32.6172L0.62793 33.6063L4.51879 40.6714L5.79706 40.3417C8.39844 39.6587 11.1344 40.1297 13.4554 41.5428C13.4779 41.5545 13.5115 41.5781 13.5339 41.5899C15.8662 43.0029 17.6378 45.2519 18.3891 47.972L18.7479 49.2908H26.5184L26.8772 47.9602C27.6285 45.2402 29.3889 42.9911 31.7212 41.5781C31.7324 41.5781 31.7436 41.5663 31.7548 41.5545C31.766 41.5545 31.7773 41.5428 31.7885 41.531C33.5713 40.4477 35.6008 39.906 37.6191 40.0238"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.7567 39.0229L39.9963 41.4721C38.4714 43.5799 37.9331 46.0644 39.1666 48.3724L41.2521 52.2582"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.6658 39.0229L49.4262 41.4721C50.9511 43.5799 51.4894 46.0644 50.2559 48.3724L48.1255 52.3406"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9962 41.4721C38.4376 43.6034 37.8882 46.0762 39.1665 48.3724"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.7168 28.9787V47.501"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.4417 14.0831C49.2357 14.4952 50.9513 15.4255 52.3417 16.8856C53.7433 18.3457 54.6179 20.1473 55.0103 22.0313"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.9238 9.51434C50.6373 10.1384 53.2275 11.5397 55.3355 13.7534C57.4435 15.9671 58.7891 18.6872 59.3722 21.5368"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.6099 18.6283C48.3387 18.7932 49.0339 19.17 49.6058 19.7705C50.1776 20.371 50.5364 21.1011 50.6934 21.8665"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.6608 21.0304C43.2592 21.0304 42.0258 21.8429 41.3866 23.044L30.2298 21.9489C29.0861 19.0758 26.395 17.0504 23.2442 17.0504C19.0618 17.0504 15.6755 20.6065 15.6755 24.9987C15.6755 29.3908 19.0618 32.9469 23.2442 32.9469C26.395 32.9469 29.0861 30.9216 30.2298 28.0484L41.3866 26.9533C42.037 28.1544 43.2592 28.9669 44.6608 28.9669C46.7464 28.9669 48.4283 27.1888 48.4283 25.0104C48.4283 22.832 46.7352 21.054 44.6608 21.054V21.0304Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_564_17711">
        <rect width="60" height="53" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default RearAndMachineSVG;
